var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "site-header" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "nav-toggle",
        attrs: { href: "#" },
        on: { click: _vm.onNavToggle }
      },
      [_vm._m(1)]
    ),
    _vm._v(" "),
    _c("ul", { staticClass: "action-list" }, [
      _c(
        "li",
        [
          _c(
            "v-dropdown",
            { attrs: { "show-arrow": false } },
            [
              _c(
                "a",
                {
                  staticClass: "dropdown-header",
                  attrs: {
                    slot: "activator",
                    href: "#",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  },
                  slot: "activator"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$currentUser.name) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c("v-dropdown-item", [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-sign-out" }),
                    _vm._v(" Выйти\n                    ")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("v-dropdown-item", [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.profile.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "icon-fa icon-fa-user" }),
                    _vm._v(" Профиль\n                    ")
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.$currentUser.role == "admin"
                ? _c("v-dropdown-item", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.settings.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-cogs" }),
                        _vm._v(" Настройки\n                    ")
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$currentUser.role == "admin" ||
              _vm.$currentUser.role == "leader"
                ? _c("v-dropdown-item", [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.users.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "icon-fa icon-fa-users" }),
                        _vm._v(" Пользователи\n                    ")
                      ]
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "brand-main", attrs: { href: "#" } }, [
      _c("img", {
        staticClass: "d-none d-md-inline",
        staticStyle: {
          height: "59px!important",
          "padding-top": "0!important",
          "margin-top": "-12px!important",
          "margin-left": "-15px!important"
        },
        attrs: {
          id: "logo-desk",
          src: "/assets/img/logo2.png",
          alt: "Laraspace Logo"
        }
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "d-md-none",
        attrs: {
          id: "logo-mobile",
          src: "/assets/img/logo2.png",
          alt: "Laraspace Logo"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hamburger hamburger--arrowturn" }, [
      _c("div", { staticClass: "hamburger-box" }, [
        _c("div", { staticClass: "hamburger-inner" })
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-555213ad", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555213ad","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/layouts/partials/TheSiteHeader.vue
// module id = 631
// module chunks = 0